var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", opacity: ".899" },
      React.createElement("path", { d: "M1.249 5.793v9.564c0 .746.604 1.35 1.35 1.35H15.68a1.35 1.35 0 0 0 1.35-1.35V5.793H1.25z", stroke: "#545454", strokeWidth: "1.3", fill: "#F3F3F3" }),
      React.createElement("path", { fill: "#545454", d: "M.955 14.3h16.494v1.3H.955zM.926 5.143h15.308v1H.926zM5.182.5h1.296v2.332H5.182zM12.138.5h1.296v2.332h-1.296z" }),
      React.createElement("path", { d: "M1.206 3.95h15.851V3.3a1.35 1.35 0 0 0-1.35-1.35H2.556a1.35 1.35 0 0 0-1.35 1.35v.65z", stroke: "#545454", strokeWidth: "1.3" })
    )
  );
});